import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { ContactTypeEnums } from 'src/app/enum/contact-type-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ConstructionSiteModel } from 'src/app/models/archive/construction-site.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CityTableModel } from 'src/app/models/tables/management/city-table.model';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { ValidateEmailService } from 'src/app/services/global-services/validate-email.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CityService } from 'src/app/services/management/city.service';
import { DepartmentService } from 'src/app/services/management/department.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { FreightService } from 'src/app/services/management/freight.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';
import { FreightModalComponent } from 'src/app/views/management/freight/freight-modal/freight-modal.component';
import { ContactReferenceModalComponent } from '../../contact-reference-modal/contact-reference-modal.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-construction-site',
  templateUrl: './register-construction-site.component.html',
  styleUrls: ['./register-construction-site.component.scss'],
  standalone: false
})
export class RegisterConstructionSiteComponent implements OnInit {

  @ViewChild('selectCityOrigin') selectCityOriginModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectCityDestiny') selectCityDestinyModalComponent?: CustomModalComponent | null = null;
  @ViewChild('contactModal') contactModalComponent?: CustomModalComponent | null = null;
  @ViewChild('freightModal') freightModalComponent?: CustomModalComponent | null = null;

  ascendantCity: boolean = true;
  branchId: number = 0;
  cityCodeNameDestiny: string = '';
  cityCodeNameOrigin: string = '';
  cityDestinyId: number = 0;
  cityOriginId: number = 0;
  code: number = 0;
  columnSortCity: string | null = null;
  component = CustomTableSelectComponent;
  componentContactModal = ContactReferenceModalComponent;
  componentFreightModal = FreightModalComponent;
  constructionSiteContract: ConstructionSiteModel = new ConstructionSiteModel();
  constructionSiteId: number = 0;
  dataCity: PagedResponseModel<CityTableModel> = new PagedResponseModel<CityTableModel>();
  departmentCodeNameDestiny: string = '';
  departmentCodeNameOrigin: string = '';
  departmentDestinyId: number = 0;
  departmentOriginId: number = 0;
  disabledbutton: boolean = false;
  disabledFreight: boolean = false;
  enterpriseId: number = 0;
  filtersCity: ColumnResponseModel[] = [];
  formConstructionSite: FormGroup = new FormGroup({});
  headerCity: ColumnResponseModel[] = [];
  inputsForCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  inputsForContactModals$ = new BehaviorSubject<any>({
    entityId: 0,
    isContact: false,
    typeContact: ContactTypeEnums.constructionSite
  });
  inputsForFreightModals$ = new BehaviorSubject<any>({
    sectorCodeName: '',
    cityCodeNameDestiny: '',
    cityCodeNameOrigin: '',
    permissionUpdatable: false,
    departmentCodeNameDestiny: '',
    departmentCodeNameOrigin: '',
    constructionSiteContract: new ConstructionSiteModel(),
  });
  isOpened: string | undefined = undefined;
  limitCity: number = 10;
  listBranches: CustomListDropdown[] = [];
  listClients: any[] = [];
  listConcepts: CustomListDropdown[] = [];
  listConstructionSiteState: CustomListDropdown[] = [
    { label: 'Activa', value: 1 },
    { label: 'Suspendida', value: 2 },
    { label: 'Inactiva', value: 3 }];
  listEnterprises: CustomListDropdown[] = [];
  listInvoiceMonthly: any[] = [
    { label: 'Mensual', value: true },
    { label: 'Quincenal', value: false }];
  listSectors: CustomListDropdown[] = [];
  listSellers: CustomListDropdown[] = [];
  listZones: CustomListDropdown[] = [];
  nameWindow: string = 'Captura Obras';
  outputForCity$ = new Subject<any>();
  pageCity: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  sectorCodeName: string = '';
  sectorId: number | null = 0;
  stateClientId: number = ClientStateEnums.activo;
  stateConstructionSiteId: number = 0;
  stateOpen: number = ConstructionSiteStateEnums.activa;
  stateOpenClient: number = ClientStateEnums.activo;
  suscription: Subscription;
  swFreight: boolean = false;
  typeContact: number = ContactTypeEnums.constructionSite;
  url: string = "construction-site";
  visibleAdvancedOptions: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private cdr: ChangeDetectorRef,
    private cityService: CityService,
    private confirmDialogService: ConfirmDialogService,
    private constructionSiteService: ConstructionSiteService,
    private dateConverterService: DateConverterService,
    private departmentService: DepartmentService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private freightService: FreightService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private validateEmailService: ValidateEmailService,
    private windowService: WindowService) {
    this.validateForm(this.constructionSiteContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.constructionSiteId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.suscription = this.outputForCity$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    await Promise.all([
      this.getAllLists('enterprises', 'sellers', 'zones'),
      this.getFirstEnterpriseByBranch(branchId),
      this.getCityDepartmentBranch(branchId)
    ]);
    this.constructionSiteId = 0;
    this.visibleAdvancedOptions = false;
    this.constructionSiteContract = new ConstructionSiteModel();
    this.constructionSiteContract.branchId = branchId;
    this.constructionSiteContract.enterpriseId = this.enterpriseId;
    this.validateForm(this.constructionSiteContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeCode() {
    const branchId = this.formConstructionSite.get("branchId")?.value;
    let code = this.formConstructionSite.get("code")?.value;
    if (this.constructionSiteContract.code == code) return;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (code == 0) {
      code = null;
    }
    this.branchId = branchId
    this.code = code;
    if (code == null) {
      this.constructionSiteId = 0;
      this.constructionSiteContract = new ConstructionSiteModel();
      this.constructionSiteContract.branchId = branchId;
    } else {
      try {
        const response = await firstValueFrom(
          this.constructionSiteService.getConstructionSiteByCode(branchId, code)
        );
        this.constructionSiteId = response.constructionSiteId;
        this.constructionSiteContract = response;
        this.validateForm(this.constructionSiteContract);
      } catch (error) {
        this.constructionSiteContract = new ConstructionSiteModel();
        this.constructionSiteContract.constructionSiteId = -1;
        this.constructionSiteContract.branchId = branchId;
        this.constructionSiteContract.code = code;
        console.error('Error al buscar la obra por codigo.', error);
      }
    }
  }

  async createCostCenter(response: ConstructionSiteModel) {
    try {
      const costCenter = await firstValueFrom(this.constructionSiteService.createCostCenter(response));
      this.toastHandlerService.showToast(
        'success',
        `El c.costos ${costCenter.code} fue creado exitosamente.`
      );
    } catch (error) {
      console.error('Error al crear el centro de costos.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para crear obras. Comuníquese con el administrador del sistema.`
      );
      return;
    }

    this.constructionSiteId = 0;
    this.constructionSiteContract = new ConstructionSiteModel();
    this.constructionSiteContract.branchId = this.branchId;
    this.constructionSiteContract.enterpriseId = this.enterpriseId;
    this.visibleAdvancedOptions = false;
    this.validateForm(this.constructionSiteContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  copyDataConstructionSite() {
    const address = this.formConstructionSite.get("address")?.value;
    const phone = this.formConstructionSite.get("phone")?.value;
    const alterPhone = this.formConstructionSite.get("alterPhone")?.value;
    const email = this.formConstructionSite.get("email")?.value;
    this.formConstructionSite.controls["invoiceAddress"].patchValue(address);
    this.formConstructionSite.controls["invoicePhone"].patchValue(phone);
    this.formConstructionSite.controls["invoiceAlterPhone"].patchValue(alterPhone);
    this.formConstructionSite.controls["invoiceEmail"].patchValue(email);
  }

  async deleteConstructionSite() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar obras. Comuníquese con el administrador del sistema.`
      );
      return;
    }

    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la obra?')) {
      try {
        await firstValueFrom(
          this.constructionSiteService.deleteConstructionSite(this.constructionSiteContract.constructionSiteId)
        );
        this.toastHandlerService.showToast(
          'success',
          `La obra fue eliminada exitosamente.`
        );
        this.createNewRegister();
      } catch (error) {
        console.error('Error al eliminar la obra.', error);
      }
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'sellers' | 'zones' | 'concepts' | 'clients'>) {
    try {
      const lists = {
        branches: async () => {
          const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
          this.listBranches = response;
        },
        enterprises: async () => {
          const response = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
          this.listEnterprises = response;
        },
        sellers: async () => {
          const response = await firstValueFrom(this.constructionSiteService.getAllSellersForSelect(this.branchId));
          this.listSellers = response;
        },
        zones: async () => {
          const response = await firstValueFrom(this.constructionSiteService.getAllZonesForSelect(this.branchId));
          this.listZones = response;
        },
        concepts: async () => {
          const response = await firstValueFrom(this.constructionSiteService.getAllConceptsForSelect());
          this.listConcepts = response;
        },
        clients: async () => {
          const response = await firstValueFrom(this.constructionSiteService.getAllClientsForSelect());
          this.listClients = response;
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.enterprises(),
          lists.sellers(),
          lists.zones(),
          lists.concepts(),
          lists.clients()
        ]);
      }
    } catch (error) {
      console.error('Error al obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formConstructionSite.get("branchId")?.value;
    this.enterpriseId = this.formConstructionSite.get("enterpriseId")?.value;
    this.code = this.formConstructionSite.get("code")?.value;
    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        `Seleccione una sucursal.`
      );
      return;
    } else if (this.code == null) {
      this.code = 0;
    }
    await this.handleInternalOrderNavigation(buttonClick, this.branchId, this.code)
  }

  async getCityDepartmentBranch(branchId: number | null) {
    if (branchId && branchId !== 0) {
      try {
        const response = await firstValueFrom(this.branchService.getBranchById(branchId));
        await Promise.all([
          this.getSectorsByCityForSelect(response.cityId),
          this.getOriginDepartment(response.departmentId),
          this.getOriginCity(response.cityId),
          this.getDestinityDepartment(response.departmentId),
          this.getDestinityCity(response.cityId)
        ]);
      } catch (error) {
        console.error('Error al obtener la sucursal.', error);
      }
    }
  }

  async getCitiesForSelection() {
    try {
      this.dataCity = await firstValueFrom(
        this.cityService.getCitiesForSelection(
          this.pageCity, this.limitCity, this.columnSortCity, this.ascendantCity, this.filtersCity
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los ciudades.', error);
    }
  }

  async getColumnsCity() {
    try {
      if (this.headerCity.length === 0) {
        this.headerCity = await firstValueFrom(this.cityService.getColumnsForCitySelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getClient(clientId: number | null, changed: boolean) {
    if (clientId === null || clientId === 0) {
      return;
    }
    try {
      if (this.constructionSiteId !== 0) {
        const client = this.listClients.find(x => x.value === clientId);
        this.stateClientId = client ? client.active : 0;
      }
      if (changed) {
        const response = await firstValueFrom(
          this.constructionSiteService.getClientByIdForRegisterAsync(clientId)
        );

        if (await this.confirmDialogService.confirm(
          '¿Desea cargar los datos de facturación electrónica (Dirección, Teléfono, Teléfono alterno, Correo) con base en los datos del cliente?'
        )) {
          this.formConstructionSite.patchValue({
            invoiceAddress: response.address,
            invoicePhone: response.phone,
            invoiceAlterPhone: response.alterPhone,
            invoiceEmail: response.email,
          });
        }
      }
    } catch (error) {
      console.error('Error al obtener el cliente.', error);
    }
  }

  async getConstructionSiteById() {
    try {
      const response = await firstValueFrom(
        this.constructionSiteService.getConstructionSiteById(this.constructionSiteId)
      );
      this.constructionSiteContract = response;
      this.branchId = response.branchId;
      await this.getAllLists();
      this.cdr.detectChanges();
      this.code = response.code;
      this.enterpriseId = response.enterpriseId;
      this.validateForm(this.constructionSiteContract);
    } catch (error) {
      console.error('Error al obtener la obra.', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = branch.branchId;
      await this.getAllLists();
      await Promise.all([
        this.getFirstEnterpriseByBranch(branch.branchId),
        this.getCityDepartmentBranch(branch.branchId)
      ]);
    } catch (error) {
      console.error('Error al obtener la sucursal principal del usuario autenticado.', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      this.enterpriseId = response.enterpriseId;
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`,
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getPermissionProfileByUrl();
    this.getGeneralParametersByCompany();
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swFreight = response.some(x => x.name === "GeneraFletes");
      });
      resolve(true);
    });
  }

  async getOriginCity(originCityId: number | null) {
    try {
      if (originCityId && originCityId !== 0) {
        const cityOrigin = await firstValueFrom(this.cityService.getCityById(originCityId));
        this.cityOriginId = cityOrigin.cityId;
        this.cityCodeNameOrigin = `${cityOrigin.code} - ${cityOrigin.name}`;
      } else {
        this.cityOriginId = 0;
        this.cityCodeNameOrigin = '';
      }
    } catch (error) {
      this.cityOriginId = 0;
      this.cityCodeNameOrigin = '';
      console.error('Error al obtener la ciudad de origen.', error);
    }
  }

  async getDestinityCity(destinityCityId: number | null) {
    try {
      if (destinityCityId != null && destinityCityId !== 0) {
        const cityOrigin = await firstValueFrom(this.cityService.getCityById(destinityCityId));
        this.cityDestinyId = cityOrigin.cityId;
        this.cityCodeNameDestiny = `${cityOrigin.code} - ${cityOrigin.name}`;
      } else {
        this.cityDestinyId = 0;
        this.cityCodeNameDestiny = '';
      }
    } catch (error) {
      this.cityDestinyId = 0;
      this.cityCodeNameDestiny = '';
      console.error('Error al obtener la ciudad de origen.', error);
    }
  }

  async getSelectedItemsCityOrigin(selectedItems: any) {
    const cityOrigin = selectedItems[0];
    const previousCityId = this.constructionSiteContract.originCityId;
    if (previousCityId === cityOrigin.id) return;
    if (this.constructionSiteId && this.swFreight) {
      if (await this.hasFreights()) {
        this.toastHandlerService.showToast(
          'warning',
          `No se puede cambiar la ciudad origen mientras existan fletes asignados a la obra.
          Por favor, elimínelos primero e intente de nuevo.`
        );
        return;
      }
      this.disabledFreight = true;
    }
    this.cityOriginId = cityOrigin.id;
    this.departmentOriginId = cityOrigin.departmentId;
    this.cityCodeNameOrigin = `${cityOrigin.code} - ${cityOrigin.name}`;
    this.departmentCodeNameOrigin = `${cityOrigin.departmentCode} - ${cityOrigin.departmentName}`;
  }

  async getSelectedItemsCityDestiny(selectedItems: any) {
    const cityDestiny = selectedItems[0];
    const previousCityId = this.constructionSiteContract.destinityCityId;
    if (previousCityId === cityDestiny.id) return;
    if (this.constructionSiteId && this.swFreight) {
      if (await this.hasFreights()) {
        this.toastHandlerService.showToast(
          'warning',
          `No se puede cambiar la ciudad destino mientras existan fletes asignados a la obra.
          Por favor, elimínelos primero e intente de nuevo.`
        );
        return;
      }
    }
    this.cityDestinyId = cityDestiny.id;
    this.departmentDestinyId = cityDestiny.departmentId;
    this.cityCodeNameDestiny = `${cityDestiny.code} - ${cityDestiny.name}`;
    this.departmentCodeNameDestiny = `${cityDestiny.departmentCode} - ${cityDestiny.departmentName}`;
    if (this.swFreight) {
      this.disabledFreight = true;
      this.formConstructionSite.controls["sectorId"].setValue(null);
      await this.getSectorsByCityForSelect(this.cityDestinyId);
    }
  }

  async getSectorsByCityForSelect(cityDestinyId: number) {
    try {
      if (this.swFreight && cityDestinyId) {
        this.listSectors = await firstValueFrom(
          this.constructionSiteService.getSectorsByCityForSelect(cityDestinyId)
        );
      }
    } catch (error) {
      console.error('Error al cargar sectores por ciudad.', error);
    }
  }

  async getSector(sectorId: number | null, reload: boolean) {
    if (!this.swFreight) return;
    const currentSectorId = sectorId;
    this.sectorId = currentSectorId;
    this.formConstructionSite.controls["sectorId"].patchValue(currentSectorId);
    this.sectorCodeName = this.listSectors.find(x => x.value == sectorId)?.label ?? '';
    if (reload) {
      const previousSectorId = this.constructionSiteContract.sectorId;
      if (previousSectorId !== currentSectorId) {
        if (await this.hasFreights()) {
          this.formConstructionSite.controls["sectorId"].patchValue(previousSectorId);
          this.toastHandlerService.showToast(
            'warning',
            `No se puede modificar el sector, mientras existan fletes asignados a la obra.
            Por favor, elimínelos primero e intente de nuevo.`
          );
          return;
        }
        this.disabledFreight = true;
      }
    }
  }

  onZoneSelected(zoneId: number | null) {
    if (zoneId === null || zoneId === 0) return;
    const zone = this.listZones.find(x => x.value === zoneId) as any;
    if (zone && zone.sellerId) {
      const sellerExists = this.listSellers.some(x => x.value === zone.sellerId);
      if (sellerExists) {
        this.formConstructionSite.controls["sellerId"].patchValue(zone.sellerId);
      }
    }
  }

  async getOriginDepartment(originDepartmentId: number | null) {
    try {
      if (originDepartmentId != null && originDepartmentId !== 0) {
        const department = await firstValueFrom(this.departmentService.getDepartmentById(originDepartmentId));
        this.departmentOriginId = department.departmentId;
        this.departmentCodeNameOrigin = `${department.code} - ${department.name}`;
      } else {
        this.departmentOriginId = 0;
        this.departmentCodeNameOrigin = '';
      }
    } catch (error) {
      this.departmentOriginId = 0;
      this.departmentCodeNameOrigin = '';
      console.error('Error al obtener el departamento de origen.', error);
    }
  }

  async getDestinityDepartment(destinityDepartmentId: number | null) {
    try {
      if (destinityDepartmentId != null && destinityDepartmentId !== 0) {
        const department = await firstValueFrom(this.departmentService.getDepartmentById(destinityDepartmentId));
        this.departmentDestinyId = department.departmentId;
        this.departmentCodeNameDestiny = `${department.code} - ${department.name}`;
      } else {
        this.departmentDestinyId = 0;
        this.departmentCodeNameDestiny = '';
      }
    } catch (error) {
      this.departmentDestinyId = 0;
      this.departmentCodeNameDestiny = '';
      console.error('Error al obtener el departamento de origen.', error);
    }
  }

  async handleInitialState() {
    if (this.constructionSiteId !== null && this.constructionSiteId !== 0) {
      await this.getConstructionSiteById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewRegister();
    }
  }

  private async handleInternalOrderNavigation(buttonClick: any, branchId: number, code: number) {
    const actionMap: Record<string, () => Promise<ConstructionSiteModel>> = {
      first: async () =>
        await firstValueFrom(this.constructionSiteService.getFirstConstructionSiteByKeysAsync(branchId)),
      previus: async () =>
        await firstValueFrom(this.constructionSiteService.getPreviusConstructionSiteByKeysAsync(branchId, code)),
      next: async () =>
        await firstValueFrom(this.constructionSiteService.getNextConstructionSiteByKeysAsync(branchId, code)),
      last: async () =>
        await firstValueFrom(this.constructionSiteService.getLastConstructionSiteByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.constructionSiteId = 0;
      this.constructionSiteContract = new ConstructionSiteModel();
      this.constructionSiteContract.branchId = branchId;
      return;
    }
    try {
      const constructionSite = await action();
      this.constructionSiteContract = constructionSite;
      this.constructionSiteId = constructionSite.constructionSiteId;
      this.validateForm(constructionSite);
      this.location.replaceState(`/${this.url}/register/${this.constructionSiteId}`);
    } catch (error) {
      this.constructionSiteContract = new ConstructionSiteModel();
      this.constructionSiteContract.constructionSiteId = 0;
      this.constructionSiteContract.branchId = branchId;
      this.constructionSiteContract.code = code;
      console.error(`Error al buscar la obra (${buttonClick.target.id}).`, error);
    }
  }

  async loadLocationData(constructionSite: ConstructionSiteModel) {
    await Promise.all([
      this.getOriginDepartment(constructionSite.originDepartmentId),
      this.getOriginCity(constructionSite.originCityId),
      this.getDestinityDepartment(constructionSite.destinityDepartmentId),
      this.getDestinityCity(constructionSite.destinityCityId)
    ]);
  }

  openContactModal() {
    this.inputsForContactModals$.next({
      entityId: this.constructionSiteContract.constructionSiteId,
      typeContact: this.typeContact,
      isContact: true
    });

    if (this.constructionSiteContract.constructionSiteId == 0 ||
      this.constructionSiteContract.constructionSiteId == null) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear una obra.`
      );
      return;
    }

    this.contactModalComponent?.show();
  }

  openFreightModal() {
    const previousSectorId = this.constructionSiteContract.sectorId;
    const currentSectorId = this.formConstructionSite.get("sectorId")?.value;
    if (previousSectorId !== currentSectorId) {
      this.toastHandlerService.showToast(
        'warning',
        'Existen cambios en el sector sin guardar.'
      );
      return;
    }
    this.updateInputsForFreight();
    this.freightModalComponent?.show();
  }

  async openSelectionCityOriginModal() {
    if (this.constructionSiteContract.constructionSiteStateId != ConstructionSiteStateEnums.activa) {
      this.toastHandlerService.showToast(
        'warning',
        `Para modificar la ciudad origen. La obra debe estar en estado activa.`
      );
      return;
    }
    this.filtersCity = [];
    await Promise.all([
      this.getColumnsCity(),
      this.getCitiesForSelection()
    ]);
    this.updateInputs();
    this.selectCityOriginModalComponent?.show();
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersCity = this.removeDuplicates(filters);
    this.filtersCity.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageCity = event.page;
    this.limitCity = event.pageSize;
    this.columnSortCity = event.sortField || null;
    this.ascendantCity = event.sortOrder === 1;
    await this.getCitiesForSelection();
  }

  async openSelectionDestinyModal() {
    if (this.constructionSiteContract.constructionSiteStateId != ConstructionSiteStateEnums.activa) {
      this.toastHandlerService.showToast(
        'warning',
        `Para modificar la ciudad origen. La obra debe estar en estado activa.`
      );
      return;
    }
    this.filtersCity = [];
    await Promise.all([
      this.getColumnsCity(),
      this.getCitiesForSelection()
    ]);
    this.updateInputs();
    this.selectCityDestinyModalComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCity = this.filtersCity.filter(f => f.propertyName !== propertyName);
    } else {

      const existingFilter = this.filtersCity.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.validateFormControls();
    if (!this.formConstructionSite.valid) {
      this.showValidationMessages();
      return;
    }

    this.formConstructionSite.enable();
    const modelConstructionSite = this.formConstructionSite.value as ConstructionSiteModel;
    modelConstructionSite.originCityId = this.cityOriginId;
    modelConstructionSite.originDepartmentId = this.departmentOriginId;
    modelConstructionSite.destinityCityId = this.cityDestinyId;
    modelConstructionSite.destinityDepartmentId = this.departmentDestinyId;
    if (modelConstructionSite.alterCode?.trim() == "") modelConstructionSite.alterCode = null;
    if (modelConstructionSite.address?.trim() == "") modelConstructionSite.address = null;
    if (modelConstructionSite.phone?.trim() == "") modelConstructionSite.phone = null;
    if (modelConstructionSite.alterPhone?.trim() == "") modelConstructionSite.alterPhone = null;
    if (modelConstructionSite.email?.trim() == "") modelConstructionSite.email = null;
    if (modelConstructionSite.invoiceAddress?.trim() == "") modelConstructionSite.invoiceAddress = null;
    if (modelConstructionSite.invoicePhone?.trim() == "") modelConstructionSite.invoicePhone = null;
    if (modelConstructionSite.invoiceAlterPhone?.trim() == "") modelConstructionSite.invoiceAlterPhone = null;
    if (modelConstructionSite.invoiceEmail?.trim() == "") modelConstructionSite.invoiceEmail = null;
    if (modelConstructionSite.observation?.trim() == "") modelConstructionSite.observation = null;
    if (!this.validateEmails()) return;
    if (this.constructionSiteId == 0) {
      try {
        const response = await firstValueFrom(
          this.constructionSiteService.createConstructionSite(modelConstructionSite)
        );
        this.constructionSiteId = response.constructionSiteId;
        this.constructionSiteContract = response;
        this.validateForm(this.constructionSiteContract);
        this.location.replaceState(`/${this.url}/register/${this.constructionSiteId}`);

        if (await this.confirmDialogService.confirm('¿Desea crear un c.costos para esta nueva obra?')) {
          await this.createCostCenter(response);
        } else {
          this.toastHandlerService.showToast(
            'success',
            `La obra fue creada exitosamente.`
          );
        }

      } catch (error) {
        console.error('Error al crear la obra.', error);
        return;
      }
    } else {
      const updatedContract = JSON.parse(JSON.stringify(this.constructionSiteContract));
      updatedContract.name = modelConstructionSite.name;
      updatedContract.alterCode = modelConstructionSite.alterCode;
      updatedContract.enterpriseId = modelConstructionSite.enterpriseId;
      updatedContract.clientId = modelConstructionSite.clientId;
      updatedContract.address = modelConstructionSite.address;
      updatedContract.phone = modelConstructionSite.phone;
      updatedContract.alterPhone = modelConstructionSite.alterPhone;
      updatedContract.email = modelConstructionSite.email;
      updatedContract.invoiceAddress = modelConstructionSite.invoiceAddress;
      updatedContract.invoicePhone = modelConstructionSite.invoicePhone;
      updatedContract.invoiceAlterPhone = modelConstructionSite.invoiceAlterPhone;
      updatedContract.invoiceEmail = modelConstructionSite.invoiceEmail;
      updatedContract.conceptId = modelConstructionSite.conceptId;
      updatedContract.zoneId = modelConstructionSite.zoneId;
      updatedContract.sellerId = modelConstructionSite.sellerId;
      updatedContract.swIcaRetainer = modelConstructionSite.swIcaRetainer;
      updatedContract.swInvoiceMonthly = modelConstructionSite.swInvoiceMonthly;
      updatedContract.originDepartmentId = modelConstructionSite.originDepartmentId;
      updatedContract.originCityId = modelConstructionSite.originCityId;
      updatedContract.destinityDepartmentId = modelConstructionSite.destinityDepartmentId;
      updatedContract.destinityCityId = modelConstructionSite.destinityCityId;
      updatedContract.sectorId = modelConstructionSite.sectorId;
      updatedContract.stateChangeDate = modelConstructionSite.stateChangeDate;
      updatedContract.constructionSiteStateId = modelConstructionSite.constructionSiteStateId;
      updatedContract.observation = modelConstructionSite.observation;
      try {
        const response = await firstValueFrom(
          this.constructionSiteService.updateConstructionSite(updatedContract)
        );
        this.constructionSiteContract = response;
        this.validateForm(this.constructionSiteContract);
        this.toastHandlerService.showToast(
          'success',
          `La obra fue modificada exitosamente.`
        );
      } catch (error) {
        this.updateFormState(this.constructionSiteContract.constructionSiteStateId);
        console.error('Error al actualizar la obra.', error);
      }
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      code: {
        required: 'El código es obligatorio.'
      },
      alterCode: {
        minlength: 'El código alterno debe tener mínimo 1 carácter.',
        maxlength: 'El código alterno no puede tener más de 10 caracteres.'
      },
      name: {
        required: 'El nombre es obligatorio.',
        maxlength: 'El nombre no puede tener más de 70 caracteres.'
      },
      clientId: {
        required: 'El Cliente es obligatorio.',
        min: 'Debes seleccionar un Cliente válido.'
      },
      enterpriseId: {
        required: 'La Empresa es obligatoria.',
        min: 'Debes seleccionar una Empresa válida.'
      },
      address: {
        maxlength: 'La dirección no puede tener más de 70 caracteres.'
      },
      phone: {
        minlength: 'El teléfono debe tener mínimo 1 carácter.',
        maxlength: 'El teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El teléfono alterno debe tener mínimo 1 carácter.',
        maxlength: 'El teléfono alterno no puede tener más de 15 caracteres.'
      },
      email: {
        maxlength: 'El correo electrónico no puede tener más de 250 caracteres.'
      },
      invoiceAddress: {
        maxlength: 'La dirección de facturación no puede tener más de 70 caracteres.'
      },
      invoicePhone: {
        maxlength: 'El teléfono de facturación no puede tener más de 15 caracteres.'
      },
      invoiceAlterPhone: {
        maxlength: 'El teléfono alterno de facturación no puede tener más de 15 caracteres.'
      },
      invoiceEmail: {
        maxlength: 'El correo de facturación no puede tener más de 250 caracteres.'
      },
      conceptId: {
        required: 'El Tipo de Negocio es obligatorio.',
        min: 'Debes seleccionar un Tipo de Negocio válido.'
      },
      zoneId: {
        required: 'La Zona es obligatoria.',
        min: 'Debes seleccionar una Zona válida.'
      },
      sellerId: {
        required: 'El Vendedor es obligatorio.',
        min: 'Debes seleccionar un Vendedor válido.'
      },
      originDepartmentId: {
        required: 'El Departamento de origen es obligatorio.'
      },
      originCityId: {
        required: 'La Ciudad de origen es obligatoria.'
      },
      destinityDepartmentId: {
        required: 'El Departamento de destino es obligatorio.'
      },
      destinityCityId: {
        required: 'La Ciudad de destino es obligatoria.'
      },
      stateChangeDate: {
        required: 'La fecha de cambio de estado es obligatoria.'
      },
      constructionSiteStateId: {
        required: 'El Estado de la obra es obligatorio.',
        min: 'Debes seleccionar un Estado de obra válido.'
      },
      sectorId: {
        notNumber: 'Debes seleccionar un Sector válido.'
      },
      observation: {
        maxlength: 'La observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formConstructionSite.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState(selectedStateId: number) {
    this.stateConstructionSiteId = selectedStateId;
    this.formConstructionSite.controls["constructionSiteStateId"].setValue(selectedStateId);
    if (selectedStateId == ConstructionSiteStateEnums.activa) {
      setTimeout(() => this.formConstructionSite.enable());
      if (this.constructionSiteId != 0) {
        setTimeout(() => this.formConstructionSite.controls["code"].enable());
      } else {
        setTimeout(() =>
          this.formControlStateService.setControlState(this.formConstructionSite,
            ['code', 'constructionSiteStateId', 'stateChangeDate', 'sectorId'], false
          )
        );
      }
      this.disabledbutton = false;
    } else {
      setTimeout(() => {
        this.formConstructionSite.disable();
        this.formControlStateService.setControlState(
          this.formConstructionSite,
          ['branchId', 'code', 'constructionSiteStateId', 'stateChangeDate'],
          true
        );
      });
      this.disabledbutton = true;
      this.disabledFreight = true;
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formConstructionSite.disable());
  }

  updateInputs() {
    this.inputsForCityModal$.next({
      headers: this.headerCity,
      data: this.dataCity,
      filters: this.filtersCity,
      showCheckbox: true,
      showRecover: true,
    });
  }

  updateInputsForFreight() {
    this.inputsForFreightModals$.next({
      sectorCodeName: this.sectorCodeName,
      cityCodeNameOrigin: this.cityCodeNameOrigin,
      cityCodeNameDestiny: this.cityCodeNameDestiny,
      permissionUpdatable: this.permissionUpdatable,
      departmentCodeNameOrigin: this.departmentCodeNameOrigin,
      departmentCodeNameDestiny: this.departmentCodeNameDestiny,
      constructionSiteContract: this.constructionSiteContract,
    });
  }

  async hasFreights() {
    try {
      return await firstValueFrom(this.freightService.hasFreights(this.constructionSiteId));
    } catch (error) {
      console.error('Error al validar los fletes.', error);
      return false;
    }
  }

  validateEmails() {
    const email = this.formConstructionSite.get('email')?.value;
    const invoiceEmail = this.formConstructionSite.get('invoiceEmail')?.value;
    if (!this.validateEmailService.validateEmails(email) || !this.validateEmailService.validateEmails(invoiceEmail)) {
      return false;
    }
    return true;
  }

  async validateForm(constructionSite: ConstructionSiteModel) {
    this.formConstructionSite = this.formBuilder.group({
      branchId: [constructionSite.branchId, [Validators.required, Validators.min(1)]],
      code: [constructionSite.code, [Validators.required]],
      alterCode: [constructionSite.alterCode, [Validators.minLength(1), Validators.maxLength(10)]],
      name: [constructionSite.name, [Validators.required, Validators.maxLength(70)]],
      clientId: [constructionSite.clientId, [Validators.required, Validators.min(1)]],
      enterpriseId: [constructionSite.enterpriseId, [Validators.required, Validators.min(1)]],
      address: [constructionSite.address, [Validators.maxLength(70)]],
      phone: [constructionSite.phone, [Validators.minLength(1), Validators.maxLength(15)]],
      alterPhone: [constructionSite.alterPhone, [Validators.minLength(1), Validators.maxLength(15)]],
      email: [constructionSite.email, [Validators.maxLength(250)]],
      invoiceAddress: [constructionSite.invoiceAddress, [Validators.maxLength(70)]],
      invoicePhone: [constructionSite.invoicePhone, [Validators.maxLength(15)]],
      invoiceAlterPhone: [constructionSite.invoiceAlterPhone, [Validators.maxLength(15)]],
      invoiceEmail: [constructionSite.invoiceEmail, [Validators.maxLength(250)]],
      conceptId: [constructionSite.conceptId, [Validators.required, Validators.min(1)]],
      zoneId: [constructionSite.zoneId, [Validators.required, Validators.min(1)]],
      sellerId: [constructionSite.sellerId, [Validators.required, Validators.min(1)]],
      swIcaRetainer: [constructionSite.swIcaRetainer],
      swInvoiceMonthly: [constructionSite.swInvoiceMonthly],
      originDepartmentId: [constructionSite.originDepartmentId, [Validators.required]],
      originCityId: [constructionSite.originCityId, [Validators.required]],
      destinityDepartmentId: [constructionSite.destinityDepartmentId, [Validators.required]],
      destinityCityId: [constructionSite.destinityCityId, [Validators.required]],
      sectorId: [constructionSite.sectorId, [CustomValidators.numberOnlyValidator()]],
      stateChangeDate: [constructionSite.stateChangeDate ? this.dateConverterService.convertUtcToLocalDate(constructionSite.stateChangeDate)
        : null, [Validators.required]],
      constructionSiteStateId: [constructionSite.constructionSiteStateId, [Validators.required, Validators.min(1)]],
      observation: [constructionSite.observation, [Validators.maxLength(250)]]
    });
    const isExistingConstructionSite = this.constructionSiteContract.constructionSiteId != 0;
    if (isExistingConstructionSite) {
      await this.getSectorsByCityForSelect(constructionSite.destinityCityId);
      await this.loadLocationData(constructionSite);
      await this.getSector(constructionSite.sectorId, false);
      this.getClient(constructionSite.clientId, false)
      this.visibleAdvancedOptions = true;
    }
    this.disabledFreight = !isExistingConstructionSite;
    this.updateFormState(this.constructionSiteContract.constructionSiteStateId);
  }

  validateFormControls() {
    Object.keys(this.formConstructionSite.controls).forEach((key) => {
      const control = this.formConstructionSite.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
